import { ExecutiveSummaryAPIDataMap, ExecutiveSummaryAPIPath } from '@containers/executive-summary/models/executive-summary';
import { ExecutiveSummaryDetail } from '@containers/executive-summary/models/executive-summary-detail';
import { ExecutiveSummaryFormType } from '@containers/executive-summary/models/form/executive-summary.form';
import { ExecutiveSummaryHtmlPreview } from '@containers/executive-summary/models/response/executive-summary-html-preview';
import { axios } from '@core/axios';
import { DIPOBackBaseResponse, MessageResponse } from '@model/response/@base-response/dipo-back-base-response';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ExecutiveSummaryService {
  private static basePath = '/exsum';

  public static getExSumDetail(exSumId: number | string): Observable<ExecutiveSummaryDetail> {
    const url = `${this.basePath}/${exSumId}/meta`;
    return from(axios.get<DIPOBackBaseResponse<ExecutiveSummaryDetail>>(url)).pipe(map(({ data }) => data.data[0]));
  }

  public static submit(exSumId: number | string): Observable<MessageResponse> {
    const url = `${this.basePath}/${exSumId}/submit`;
    return from(axios.post<MessageResponse>(url)).pipe(map(({ data }) => data));
  }

  public static putSetting(exSumId: number | string, data: ExecutiveSummaryFormType): Observable<MessageResponse> {
    const url = `${this.basePath}/${exSumId}/setting`;
    return from(axios.put<MessageResponse>(url, data)).pipe(map(({ data }) => data));
  }

  public static getSetting(exSumId: number | string): Observable<ExecutiveSummaryFormType> {
    const url = `${this.basePath}/${exSumId}/setting`;
    return from(axios.get<DIPOBackBaseResponse<ExecutiveSummaryFormType>>(url)).pipe(map(({ data }) => data.data[0]));
  }

  public static getPreviewHtml(exSumId: number | string): Observable<ExecutiveSummaryHtmlPreview> {
    const url = `${this.basePath}/${exSumId}/preview/html`;
    return from(axios.get<DIPOBackBaseResponse<ExecutiveSummaryHtmlPreview>>(url)).pipe(map(({ data }) => data.data[0]));
  }

  public static getPreviewHtmlPublicByExSumId(exSumId: number | string): Observable<ExecutiveSummaryHtmlPreview> {
    const url = `/public${this.basePath}/${exSumId}/html`;
    return from(axios.get<DIPOBackBaseResponse<ExecutiveSummaryHtmlPreview>>(url)).pipe(map(({ data }) => data.data[0]));
  }

  public static getPreviewHtmlPublicBySecIdAndVersion(
    secId: number | string,
    version: string | number
  ): Observable<ExecutiveSummaryHtmlPreview> {
    const url = `/public${this.basePath}/sec/${secId}/${version}/html`;
    return from(axios.get<DIPOBackBaseResponse<ExecutiveSummaryHtmlPreview>>(url)).pipe(map(({ data }) => data.data[0]));
  }

  public static getPreviewHtmlPublicBySymbol(symbol: string): Observable<ExecutiveSummaryHtmlPreview> {
    const url = `/public${this.basePath}/set/${symbol}/html`;
    return from(axios.get<DIPOBackBaseResponse<ExecutiveSummaryHtmlPreview>>(url)).pipe(map(({ data }) => data.data[0]));
  }

  public static postPreviewPartHtml<P extends ExecutiveSummaryAPIPath>(
    exSumId: number | string,
    path: P,
    previewData: { [key: string]: ExecutiveSummaryAPIDataMap[P] }
  ): Observable<ExecutiveSummaryHtmlPreview> {
    const url = `/exsum/${exSumId}/preview/${path}/html`;
    return from(axios.post<DIPOBackBaseResponse<ExecutiveSummaryHtmlPreview>>(url, previewData)).pipe(map(({ data }) => data.data[0]));
  }

  public static pathRequestEdit(exSumId: number | string): Observable<MessageResponse> {
    const url = `${this.basePath}/${exSumId}/request-edit`;
    return from(axios.patch<MessageResponse>(url)).pipe(map(({ data }) => data));
  }
}
